module.exports = __webpack_public_path__ + "static/media/012.ea2cf64c.jpg";